(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7599],{

/***/ 14902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(34810);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(829);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/utils/createQueryHook/createQueryHook.ts
var createQueryHook = __webpack_require__(74048);
// EXTERNAL MODULE: ../../libs/utils/fsCache/index.ts
var fsCache = __webpack_require__(96904);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ../../libs/api/routes/useCases/queries/filtersQuery.ts
/* provided dependency */ var process = __webpack_require__(34406);







var groupFilters = function groupFilters(types) {
  var groupedFilters = {};
  var filters = types.filter(function (type) {
    var _type$items$validatio, _type$items$validatio2;

    return type.items && ((_type$items$validatio = type.items.validations[0]) === null || _type$items$validatio === void 0 ? void 0 : (_type$items$validatio2 = _type$items$validatio["in"]) === null || _type$items$validatio2 === void 0 ? void 0 : _type$items$validatio2.length) > 0;
  });
  filters.forEach(function (filter) {
    var _items$validations$0$;

    var items = filter.items,
        id = filter.id;
    groupedFilters[id] = {
      title: "Teams",
      items: sortBy_default()((_items$validations$0$ = items.validations[0]["in"]) === null || _items$validations$0$ === void 0 ? void 0 : _items$validations$0$.map(function (item) {
        return {
          title: item,
          id: "".concat(item.toLowerCase().replace(/\s/g, ""))
        };
      }), function (item) {
        return item.title.toLowerCase();
      })
    };
  });
  return groupedFilters;
};

var fetchFilters = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client) {
    var enabled, cachedFetch;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 3;
            return (0,fsCache/* createFsCacheProxy */.c)(["useCasesFilters"], function () {
              return client.get("/content/contentTypes/useCase").then(function (data) {
                return groupFilters(data);
              });
            }, {
              enabled: enabled
            });

          case 3:
            cachedFetch = _context.sent;
            return _context.abrupt("return", cachedFetch());

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFilters(_x) {
    return _ref.apply(this, arguments);
  };
}();
var createFiltersQuery = function createFiltersQuery(client) {
  return [["useCases/filtersQuery"], function () {
    return fetchFilters(client);
  }];
};
var useFiltersQuery = (0,createQueryHook/* default */.Z)(createFiltersQuery, contexts_staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
;// CONCATENATED MODULE: ../../libs/api/routes/useCases/queries/singleUseCaseQuery.ts



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var fetchAllUseCases = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client) {
    var data;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.get("/content/entries/useCase");

          case 2:
            data = _context.sent;
            return _context.abrupt("return", data !== null && data !== void 0 ? data : []);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchAllUseCases(_x) {
    return _ref.apply(this, arguments);
  };
}();
var createAllUseCasesQuery = function createAllUseCasesQuery(client) {
  return [["useCase", "allUseCasesQuery"], function () {
    return fetchAllUseCases(client);
  }];
};
var fetchAllRelatedRecipes = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(client) {
    var searchParams, data;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            searchParams = new URLSearchParams();
            searchParams.set("select", "sys.id,fields.slug,fields.title,fields.description,fields.useCases,fields.authors,fields.experienceLevel,fields.roles,fields.industries");
            searchParams.set("fields.useCases[exists]", "true");
            _context2.next = 5;
            return client.get("/content/entries/recipe?".concat(searchParams.toString()));

          case 5:
            data = _context2.sent;
            return _context2.abrupt("return", data !== null && data !== void 0 ? data : []);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllRelatedRecipes(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchAllUseCaseSlugs = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(client) {
    var allUseCases;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetchAllUseCases(client);

          case 2:
            allUseCases = _context3.sent;
            return _context3.abrupt("return", allUseCases === null || allUseCases === void 0 ? void 0 : allUseCases.map(function (useCase) {
              return useCase === null || useCase === void 0 ? void 0 : useCase.url;
            }));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchAllUseCaseSlugs(_x3) {
    return _ref3.apply(this, arguments);
  };
}()));
var createUseCaseQuery = function createUseCaseQuery(client, slug) {
  return [["useCase/useCaseQuery", slug], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
    var allUseCases, data;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return fetchAllUseCases(client);

          case 3:
            allUseCases = _context4.sent;
            data = allUseCases.find(function (s) {
              return s.url === slug;
            });

            if (data) {
              _context4.next = 7;
              break;
            }

            throw new Error("Use case data is empty");

          case 7:
            return _context4.abrupt("return", data);

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](0);
            console.error("Failed to find use case with ".concat(slug, ". Underlying error: ").concat(_context4.t0));

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 10]]);
  }))];
};
var useUseCaseQuery = (0,createQueryHook/* default */.Z)(createUseCaseQuery, contexts_staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
var createRelatedRecipesQuery = function createRelatedRecipesQuery(client, slug) {
  return [["useCase/relatedRecipes", slug], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
    var allRelatedRecipes, recipes, transformedResponse;
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return fetchAllRelatedRecipes(client);

          case 3:
            allRelatedRecipes = _context5.sent;
            recipes = allRelatedRecipes.reduce(function (accRecipe, recipe) {
              recipe.useCases.forEach(function (useCase) {
                if (useCase.fields.url === slug) {
                  accRecipe.push(recipe);
                }
              });
              return accRecipe;
            }, []);

            if (recipes) {
              _context5.next = 7;
              break;
            }

            throw new Error("Related use case recipes not found");

          case 7:
            transformedResponse = recipes.map(function (recipe) {
              var _recipe$authors;

              return _objectSpread(_objectSpread({}, recipe), {}, {
                authors: (_recipe$authors = recipe.authors) === null || _recipe$authors === void 0 ? void 0 : _recipe$authors.map(function (author) {
                  return _objectSpread(_objectSpread({}, author.fields), {}, {
                    headshot: {
                      title: author.fields.headshot.fields.title,
                      src: author.fields.headshot.fields.file.url
                    }
                  });
                })
              });
            });
            return _context5.abrupt("return", transformedResponse);

          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](0);
            console.error("Failed to find use case with ".concat(slug, ". Underlying error: ").concat(_context5.t0));

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 11]]);
  }))];
};
var useRelatedRecipesQuery = (0,createQueryHook/* default */.Z)(createRelatedRecipesQuery, contexts_staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
// EXTERNAL MODULE: ../../node_modules/lodash/map.js
var map = __webpack_require__(16760);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
// EXTERNAL MODULE: ../../libs/utils/createInfinityQueryHook/createInfinityQueryHook.ts
var createInfinityQueryHook = __webpack_require__(99338);
;// CONCATENATED MODULE: ../../libs/api/routes/useCases/queries/useCasesQuery.ts




function useCasesQuery_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function useCasesQuery_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? useCasesQuery_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useCasesQuery_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var DEFAULT_LIMIT = 9;
var DEFAULT_OFFESET = 0;
var cachedUseCasesArraySize = 0;
var getUseCasesArraySize = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client) {
    var data;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!cachedUseCasesArraySize) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", cachedUseCasesArraySize);

          case 2:
            _context.next = 4;
            return client.get("/content/entries/useCase");

          case 4:
            data = _context.sent;
            cachedUseCasesArraySize = data.length;
            return _context.abrupt("return", cachedUseCasesArraySize);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getUseCasesArraySize(_x) {
    return _ref.apply(this, arguments);
  };
}();
var fetchUseCases = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(client) {
    var filters,
        pagination,
        searchParams,
        _pagination$offset,
        offset,
        _pagination$limit,
        limit,
        result,
        allResultsSize,
        pageResult,
        _args2 = arguments;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            filters = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            pagination = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
            searchParams = new URLSearchParams();

            map_default()(filters, function (value, key) {
              var filterParams = value.map(function (item) {
                return item.value;
              });
              searchParams.set("fields.".concat(key).concat(filterParams.length > 1 ? "[in]" : ""), filterParams.toString());
            });

            _pagination$offset = pagination.offset, offset = _pagination$offset === void 0 ? DEFAULT_OFFESET : _pagination$offset, _pagination$limit = pagination.limit, limit = _pagination$limit === void 0 ? DEFAULT_LIMIT : _pagination$limit;
            searchParams.set("limit", limit.toString());
            searchParams.set("offset", offset.toString());
            _context2.next = 9;
            return client.get("/content/entries/useCase?".concat(searchParams.toString()));

          case 9:
            result = _context2.sent;
            _context2.next = 12;
            return getUseCasesArraySize(client);

          case 12:
            allResultsSize = _context2.sent;
            pageResult = {
              total: allResultsSize,
              skip: offset,
              limit: limit,
              items: result
            };
            return _context2.abrupt("return", pageResult);

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchUseCases(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var createFetchUseCasesQuery = function createFetchUseCasesQuery(client, filters) {
  return [["useCase", "fetchUseCasePages", filters !== null && filters !== void 0 ? filters : null], /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(_ref3) {
      var _ref3$pageParam, pagination, useCases;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref3$pageParam = _ref3.pageParam, pagination = _ref3$pageParam === void 0 ? {} : _ref3$pageParam;
              _context3.next = 3;
              return fetchUseCases(client, filters, pagination);

            case 3:
              useCases = _context3.sent;
              return _context3.abrupt("return", useCasesQuery_objectSpread(useCasesQuery_objectSpread({}, useCases), {}, {
                items: useCases.items
              }));

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }()];
};
var useUseCasesQuery = (0,createInfinityQueryHook/* default */.Z)(createFetchUseCasesQuery, contexts_staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(p) {
    var nextOffset = p.skip - p.limit;

    if (nextOffset < 0) {
      return;
    }

    return {
      offset: nextOffset,
      limit: p.limit
    };
  },
  getNextPageParam: function getNextPageParam(p) {
    var nextOffset = p.skip + p.limit;

    if (p.total <= nextOffset) {
      return;
    }

    return {
      offset: nextOffset,
      limit: p.limit
    };
  }
});
;// CONCATENATED MODULE: ../../libs/api/routes/useCases/queries/index.ts



// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/components/VideoPlayer/index.ts + 2 modules
var VideoPlayer = __webpack_require__(41926);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/components/Hero/Video.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var Video = function Video(_ref) {
  var url = _ref.url;

  var _useState = (0,react.useState)(false),
      playing = _useState[0],
      setPlaying = _useState[1];

  var play = function play() {
    return setPlaying(true);
  };

  var stop = function stop() {
    return setPlaying(false);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledElevation, {
    elevation: 7,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VideoPlayer/* default */.ZP, {
      url: url,
      playing: playing,
      onPause: stop,
      onPlay: play,
      children: [!playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* BigPlayButton */.sT, {
        ariaLabel: "Play Button",
        onClick: play
      }), !playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayerCover, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cover, {})
      })]
    })
  });
};

var StyledElevation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Elevation/* default */.Z,  true ? {
  target: "euqwrij2"
} : 0)( true ? {
  name: "18k4vjr",
  styles: "padding-top:56px;max-width:800px"
} : 0);

var VideoPlayerCover = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(VideoPlayer/* Cover */.Y9,  true ? {
  target: "euqwrij1"
} : 0)( true ? {
  name: "bigtx2",
  styles: "background:none"
} : 0);

var Cover = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "euqwrij0"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[100];
}, ";width:100%;height:100%;opacity:0.2;" + ( true ? "" : 0));

/* harmony default export */ var Hero_Video = (Video);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/components/Hero/Hero.tsx


function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var backLink = {
  text: "Use Cases",
  href: "/use-cases"
};

var Hero_Hero = function Hero(_ref) {
  var useCase = _ref.useCase;
  var badges = useCase.useCase,
      title = useCase.title,
      description = useCase.description,
      videoURL = useCase.videoURL;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroRecipeBase, {
      variant: "2Col",
      copyVariant: "wide",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroCopy, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
          href: backLink.href,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
            tag: "span",
            iconStart: Common/* ChevronLeftIcon */.wy,
            children: backLink.text
          })
        }), badges && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgesWrapper, {
          children: badges.map(function (badge) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
              variant: "outlined",
              children: badge
            }, badge);
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            children: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pExtraLarge",
            children: description
          }), videoURL && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Video, {
            url: videoURL
          })]
        })]
      })
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e3xt0b44"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledHeroRecipeBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* default */.ZP,  true ? {
  target: "e3xt0b43"
} : 0)(Hero/* Wrapper */.im, "{align-items:start;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:80px;padding-bottom:80px;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{grid-template-columns:minmax(472px, 60%);}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("xl");
}, "{grid-template-columns:minmax(844px, 60%);}}" + ( true ? "" : 0));

var StyledHeroCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* Copy */.CK,  true ? {
  target: "e3xt0b42"
} : 0)("text-align:left;display:grid;justify-items:start;row-gap:24px;", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("md");
}, "{row-gap:40px;}", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("xxl");
}, "{row-gap:32px;}" + ( true ? "" : 0));

var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e3xt0b41"
} : 0)("margin-bottom:6px;", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.up("sm");
}, "{margin-bottom:16px;}", function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.up("md");
}, "{margin-bottom:0;}", function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.up("xxl");
}, "{margin-bottom:8px;}" + ( true ? "" : 0));

var BadgesWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3xt0b40"
} : 0)( true ? {
  name: "cl7urv",
  styles: "display:flex;flex-wrap:wrap;gap:8px"
} : 0);

/* harmony default export */ var components_Hero_Hero = (Hero_Hero);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var recipes_Card = __webpack_require__(74881);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/components/Card/Card.tsx


function Card_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var Card = function Card(_ref) {
  var authors = _ref.authors,
      roles = _ref.roles,
      title = _ref.title,
      description = _ref.description,
      experienceLevel = _ref.experienceLevel,
      industries = _ref.industries,
      slug = _ref.slug;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* default */.ZP, {
    href: (0,getAbsoluteUrl/* default */.Z)("/recipes/".concat(slug), pageConfig),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCardBody, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Accessories */.v8, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* AccessoriesRow */.OW, {
          children: [roles === null || roles === void 0 ? void 0 : roles.map(function (role, key) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
              variant: "outlined",
              children: role
            }, role + key);
          }), industries === null || industries === void 0 ? void 0 : industries.map(function (industry, key) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
              variant: "outlined",
              children: industry
            }, industry + key);
          }), experienceLevel ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
            variant: "outlined",
            children: experienceLevel
          }) : null]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Headline */.s0, {
          tag: "h3",
          children: title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Description */.dk, {
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Accessories */.v8, {
        children: authors === null || authors === void 0 ? void 0 : authors.map(function (_ref2, key) {
          var name = _ref2.name,
              headshot = _ref2.headshot;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* AccessoriesRow */.OW, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Author */.S3, {
              alt: name,
              size: "small",
              src: headshot.src
            }, name), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Label */.__, {
              variant: "textTiny",
              children: ["Made by ", name]
            })]
          }, key);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Action */.aU, {
        alignment: "left",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Use this recipe"
        })
      })]
    })
  });
};

var StyledCardBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Card/* Body */.uT,  true ? {
  target: "e1iv6iq50"
} : 0)( true ? {
  name: "1u7qp61",
  styles: "align-items:flex-start;grid-template-rows:min-content min-content 1fr"
} : 0);

/* harmony default export */ var Card_Card = (Card);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/components/CardsGroup/CardsGroup.tsx


var _excluded = ["children"];

function CardsGroup_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CardsGroup_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardsGroup_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardsGroup_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var CardsGroup = function CardsGroup(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, CardsGroup_objectSpread(CardsGroup_objectSpread({
    columns: 1,
    overrides: {
      lg: 3
    }
  }, rest), {}, {
    children: children
  }));
};

/* harmony default export */ var CardsGroup_CardsGroup = (CardsGroup);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/components/CardsSection/CardsSection.tsx



var CardsSection_excluded = ["title", "isEmpty", "isLoading", "children"];

function CardsSection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CardsSection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardsSection_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardsSection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function CardsSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var CardsSection = function CardsSection(_ref2) {
  var title = _ref2.title,
      isEmpty = _ref2.isEmpty,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
      children = _ref2.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, CardsSection_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, CardsSection_objectSpread(CardsSection_objectSpread({
    isEmpty: isEmpty,
    variant: "noCopy"
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextBase, {
        isEmpty: isEmpty,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: title
        })
      }), children]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingOverlay, {
      "data-testid": "loading-overlay",
      "aria-busy": isLoading,
      isLoading: isLoading
    })]
  }));
};

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "et20q7r2"
} : 0)("margin-bottom:", function (_ref3) {
  var isEmpty = _ref3.isEmpty;
  return isEmpty ? "16px" : "40px";
}, ";" + ( true ? "" : 0));

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "et20q7r1"
} : 0)("position:relative;", function (_ref4) {
  var isEmpty = _ref4.isEmpty;
  return isEmpty && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(Section/* Wrapper */.im, "{padding-top:40px;padding-bottom:40px;}" + ( true ? "" : 0),  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "o9ww1u",
  styles: "opacity:0.5"
} : 0;

var LoadingOverlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "et20q7r0"
} : 0)("opacity:0;background-color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.neutrals.white[100];
}, ";position:absolute;top:0;left:0;bottom:0;right:0;width:100%;transition:opacity ease-in-out 0.3s;z-index:1;pointer-events:none;", function (_ref6) {
  var isLoading = _ref6.isLoading;
  return isLoading && _ref;
}, ";" + ( true ? "" : 0));

/* harmony default export */ var CardsSection_CardsSection = (CardsSection);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/components/RelatedRecipes/RelatedRecipes.tsx










var recipesLink = {
  text: "See all recipes",
  href: "/recipes"
};

var RelatedRecipes = function RelatedRecipes(_ref) {
  var recipes = _ref.recipes;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardsSection_CardsSection, {
    title: "Related recipes",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsGroup_CardsGroup, {
      children: recipes.map(function (_ref2) {
        var authors = _ref2.authors,
            title = _ref2.title,
            description = _ref2.description,
            slug = _ref2.slug,
            roles = _ref2.roles,
            experienceLevel = _ref2.experienceLevel,
            industries = _ref2.industries;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card_Card, {
          authors: authors,
          title: title,
          description: description,
          roles: roles,
          experienceLevel: experienceLevel,
          industries: industries,
          slug: slug
        }, title);
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AllRecipesWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
        tag: "a",
        href: (0,getAbsoluteUrl/* default */.Z)(recipesLink.href, pageConfig),
        iconEnd: Common/* ChevronRightIcon */.XC,
        children: recipesLink.text
      })
    })]
  });
};

var AllRecipesWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1wzr1zp0"
} : 0)("display:flex;padding-top:56px;justify-content:center;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:80px;}" + ( true ? "" : 0));

/* harmony default export */ var RelatedRecipes_RelatedRecipes = (RelatedRecipes);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/components/GettingStarted/GettingStarted.tsx


function GettingStarted_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var data = {
  heading: "Collect web and mobile analytics",
  description: "Collect data once with Segment and send it any tool you use.<br>No more tedious integrations."
};

var BaseGettingStarted = function BaseGettingStarted() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GettingStarted_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: data.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          dangerouslySetInnerHTML: {
            __html: data.description
          }
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
          children: "Request a demo"
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  });
};

/* harmony default export */ var GettingStarted = (BaseGettingStarted);
var GettingStarted_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1651vfm2"
} : 0)("overflow-y:auto;overflow-x:hidden;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1651vfm1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:40px 20px 0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1651vfm0"
} : 0)( true ? {
  name: "k6fggx",
  styles: "width:100%;margin:0 auto;text-align:center"
} : 0);
;// CONCATENATED MODULE: ./src/views/UseCases/SinglePage/UseCaseSingle.tsx












var copy = {
  pageTitle: "Twilio Segment Use Cases",
  pageDescription: "Explore top use cases for Twilio Segment and the tools that power them. Implement Segment once, integrate 250+ tools with the flip of a switch, and unlock thousands of new uses cases for marketing, personalization, analytics, and more."
};

var UseCaseSingleView = function UseCaseSingleView(_ref) {
  var slug = _ref.slug;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useUseCaseQuery = useUseCaseQuery({
    args: [slug]
  }),
      useCase = _useUseCaseQuery.data;

  var _useRelatedRecipesQue = useRelatedRecipesQuery({
    args: [slug]
  }),
      recipes = _useRelatedRecipesQue.data;

  if (!useCase || !recipes) throw new Error("Use Case or recipes is missing. Make sure it's preloaded");
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: copy.pageTitle,
      pageDescription: copy.pageDescription,
      bodyBackground: theme.palette.neutrals.white[100],
      themeColor: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Hero_Hero, {
        useCase: useCase
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedRecipes_RelatedRecipes, {
          recipes: recipes
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

/* harmony default export */ var UseCaseSingle = (UseCaseSingleView);

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e18gsu8r0"
} : 0)( true ? "" : 0);
;// CONCATENATED MODULE: ./src/pages/use-cases/[slug]/index.tsx





var UseCase = function UseCase(_ref) {
  var slug = _ref.slug;
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseCaseSingle, {
      slug: slug
    })
  });
};

var __N_SSG = true;
/* harmony default export */ var _slug_ = (UseCase);

/***/ }),

/***/ 39896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ createClient; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ../../libs/utils/retry/retry.ts



var wait = function wait(waitTime) {
  return new Promise(function (resolve) {
    setTimeout(resolve, waitTime);
  });
};

var numberSuffixes = ["st", "nd", "rd"];

var functionFailedText = function functionFailedText(iteration) {
  var _numberSuffixes$itera;

  return "Function failed. Retrying ".concat(iteration + 1).concat((_numberSuffixes$itera = numberSuffixes[iteration]) !== null && _numberSuffixes$itera !== void 0 ? _numberSuffixes$itera : "th", " time...");
};

var allRetriesFailedText = function allRetriesFailedText(retriesCount, errors) {
  return "Function failed too many times. Tired ".concat(retriesCount, " time").concat(retriesCount > 1 ? "s" : "", ".\nThrown errors:\n").concat(errors.map(function (e) {
    return e.toString();
  }).join("\n\n"), "\n");
};
/* eslint-disable no-await-in-loop */

/**
 * Retry function call
 * @param fn - The function to be called
 * @param options - The options object
 * @param options.times - Total amount of function calls. First function call is included.
 * @param options.waitTime - Wait time between retries in milliseconds
 * @returns The function with retries
 */


var retry = function retry(fn, _ref) {
  var times = _ref.times,
      waitTime = _ref.waitTime;
  return /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var errors,
        i,
        _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            errors = [];
            i = 0;

          case 2:
            if (!(i < times)) {
              _context.next = 19;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return fn.apply(void 0, _args);

          case 6:
            return _context.abrupt("return", _context.sent);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            console.log(functionFailedText(i));

            if (!(i + 1 < times)) {
              _context.next = 15;
              break;
            }

            _context.next = 15;
            return wait(waitTime);

          case 15:
            errors.push(_context.t0);

          case 16:
            i++;
            _context.next = 2;
            break;

          case 19:
            throw new Error(allRetriesFailedText(times, errors));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));
};
/* eslint-enable no-await-in-loop */


/* harmony default export */ var retry_retry = (retry);
;// CONCATENATED MODULE: ../../libs/utils/retry/index.ts

;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/client.ts
/* provided dependency */ var process = __webpack_require__(34406);



var OMIT_CACHE_PARAMETER = "omitCache";
var CONTENT_PREVIEW_PARAMETER = "contentPreview";

var isCacheDisabled = function isCacheDisabled() {
  return process.env.CI;
};

var createClient = function createClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$retry = _ref.retry,
      retryOptions = _ref$retry === void 0 ? {
    times: 3,
    waitTime: 1000
  } : _ref$retry;

  function get(_x, _x2) {
    return _get.apply(this, arguments);
  }

  function _get() {
    _get = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(url, options) {
      var fullUserUrl, fullUrl, isOmitCacheParamMissing, startTime, response, json, endTime, requestTime;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!url.startsWith("/")) {
                _context.next = 20;
                break;
              }

              fullUserUrl = "".concat("https://segment.com/backend").concat(url);
              fullUrl = new URL(fullUserUrl);
              isOmitCacheParamMissing = !fullUrl.searchParams.has(OMIT_CACHE_PARAMETER);

              if (isOmitCacheParamMissing && isCacheDisabled()) {
                fullUrl.searchParams.append(OMIT_CACHE_PARAMETER, "");
              }

              if (process.env.IS_CONTENTFUL_PREVIEW_BRANCH === "true") {
                fullUrl.searchParams.append(CONTENT_PREVIEW_PARAMETER, "true");
              }

              startTime = Date.now();
              _context.next = 9;
              return fetch(fullUrl.toString(), options);

            case 9:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 17;
                break;
              }

              _context.next = 13;
              return response.json();

            case 13:
              json = _context.sent;

              if (!(options !== null && options !== void 0 && options.responseHeaders)) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", {
                data: json,
                headers: response.headers
              });

            case 16:
              return _context.abrupt("return", json);

            case 17:
              endTime = Date.now();
              requestTime = (endTime - startTime) / 1000;
              throw new Error("HTTP error ".concat(response.status, ": ").concat(response.statusText, "\nwhile trying to fetch: ").concat(fullUrl, "\nresponse returned after: ").concat(requestTime, " seconds\n      "));

            case 20:
              throw new Error("Client supports only absolute paths (starting with /)");

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _get.apply(this, arguments);
  }

  var retryGet = retry_retry(get, retryOptions);
  return {
    get: retryGet
  };
};



/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 99338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58586);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/**
 * Creates infinite query hook from query factory
 *
 * @param fetchFactory factory function creating [query key, fetchFunction] tuple for use with react-query lib
 * @param useClientInstance hook function returning client instance to use with fetching function
 * @returns hook function wrapping useInfiniteQuery
 */

var createInfiniteQueryHook = function createInfiniteQueryHook(fetchFactory, useClientInstance, defaultOptions) {
  return function (_ref) {
    var args = _ref.args,
        options = _ref.options;
    var instance = useClientInstance();
    return _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useInfiniteQuery.apply */ .N.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fetchFactory.apply(void 0, [instance].concat((0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)))).concat([_objectSpread(_objectSpread({}, defaultOptions), options)]));
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (createInfiniteQueryHook);

/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 16201:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/[slug]",
      function () {
        return __webpack_require__(14902);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,8943,9379,1382,4136,8392,2073,7096,2429,7303,3996,8187,442,4881,3500,9774,2888,179], function() { return __webpack_exec__(16201); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);